import { StatusPedido } from '@du/shared'
import { cn } from '../lib/cn.js'

/**
 * O status é lido de longe, na correria. Então: caixa alta, Archivo Black, e
 * cor que não depende só de matiz (quem não distingue vermelho de verde tem de
 * ler o texto e enxergar a diferença de luminosidade).
 */
const ROTULO: Record<StatusPedido, string> = {
  RECEBIDO: 'NOVO',
  ACEITO: 'ACEITO',
  EM_PREPARO: 'NA CHAPA',
  PRONTO: 'PRONTO',
  SAIU_PARA_ENTREGA: 'SAIU',
  ENTREGUE: 'ENTREGUE',
  CANCELADO: 'CANCELADO',
}

export function OrderStatusPill({
  status,
  atrasadoMin,
  className,
}: {
  status: StatusPedido
  atrasadoMin?: number | undefined
  className?: string | undefined
}) {
  return (
    <span className={cn('du-status', `du-status--${status.toLowerCase()}`, className)}>
      {ROTULO[status]}
      {atrasadoMin && atrasadoMin > 0 ? (
        <span className="du-status__atraso">+{atrasadoMin}min</span>
      ) : null}
    </span>
  )
}
